
  import {Vue, Component, Prop} from "vue-property-decorator";
  import api from "@/api/index";
  import {ProjectDto} from "../../api/appService";
  import AgileAuditTag from "@/components/AgileAuditTag/index.vue";

  @Component({name: 'ProjectDetail',components:{
      AgileAuditTag
    }})
  export default class ProjectDetail extends Vue {

    @Prop()
    detail!: ProjectDto;

    show: boolean = false;

    handleClose() {
      this.show = false;
    }

  }
